<template>
    <div class="donor-addresses">
      <b-button class="float-right" @click="editRow(-1)" right size="sm" variant="primary">
        <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
      </b-button>
      <table class="table-striped table mb-0 dx-g-bs4-overflow-hidden dx-g-bs4-table">
        <thead>
          <tr>
            <th class="edit-cell" v-if="!isReadonly"></th>
            <th>Регион</th>
            <th>Город</th>
            <th>Улица</th>
            <th>Дом</th>
            <th>Корпус</th>
            <th>Квартира</th>
            <th class="delete-cell" v-if="!isReadonly"></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data && data.length > 0">
            <tr v-for="(row, index) in data" :key="'address-row-' + index + '-' + renderKey">
              <td v-if="!isReadonly">
                <a class="edit" @click="editRow(index)" href="javascript:void(0)">
                  <i class="fa fa-pencil-alt"></i>
                </a>
              </td>
              <td>{{ row.region_name }}</td>
              <td>{{ row.city }}</td>
              <td>{{ row.street }}</td>
              <td>{{ row.house }}</td>
              <td>{{ row.building }}</td>
              <td>{{ row.ap }}</td>
              <td v-if="!isReadonly">
                <a class="delete" @click="deleteRow(data, index)" href="javascript:void(0)">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td :colspan="!isReadonly ? 8 : 6" class="text-center">Нет данных</td>
            </tr>
          </template>
        </tbody>
      </table>
      <b-modal id="edit-address-modal"
              :title="$t('Адрес донора')"
              :no-close-on-backdrop="true"
              @keydown.native.enter="save"
              :cancel-disabled="false">
                  <rdkm-select
                          :label="$t('Регион')"
                          name="region_id"
                          validate="required"
                          :cols="8"
                          :labelCols="3"
                          :allowEmpty="false"
                          v-model="row.region_id"
                          @input="regionChanged"
                          :options="regions"
                  ></rdkm-select>
                  <div class="row">
                    <div class="col-3">
                      <label>
                        Город
                      </label>
                    </div>
                    <div class="col-sm-32 col-md-16 col-lg-16 col-xl-8 col-48">
                      <typeahead
                        v-model="row.city"
                        :serializer="t => t.city_type + '. ' + t.city"
                        inputClass="form-control form-control-sm"
                        @hit="currentCity = $event; row.city = $event.city"
                        @input="findCity"
                        :data="cities"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-3">
                      <label>
                        Улица
                      </label>
                    </div>
                    <div class="col-sm-32 col-md-16 col-lg-16 col-xl-8 col-48">
                      <typeahead
                        v-model="row.street"
                        :serializer="t => (t.settlement_with_type ? t.settlement_with_type + ', ' : '') + t.street_type + '. ' + t.street"
                        inputClass="form-control form-control-sm"
                        @hit="row.street = ($event.settlement_with_type ? $event.settlement_with_type + ', ' : '') + $event.street"
                        @input="findStreet"
                        :data="streets"
                      />
                    </div>
                  </div>
                  <rdkm-input
                    :label="$t('Дом')"
                    v-model="row.house"
                    :cols="8"
                    :labelCols="3"
                  ></rdkm-input>
                  <rdkm-input
                    :label="$t('Корпус')"
                    v-model="row.building"
                    :cols="8"
                    :labelCols="3"
                  ></rdkm-input>
                  <rdkm-input
                    :label="$t('Квартира')"
                    v-model="row.ap"
                    :cols="8"
                    :labelCols="3"
                  ></rdkm-input>
      <div slot="modal-footer" class="w-100">
        <div class="offset-md-3">
            <b-button :disabled="errors.any()" @click="save" size="sm" variant="primary" class="mr-1">
                <font-awesome-icon icon="check" /> {{ $t('Сохранить') }}
            </b-button>
            <b-button @click="hideModal('edit-address-modal')" size="sm" variant="default">
                <font-awesome-icon icon="times" /> {{ $t('Отмена') }}
            </b-button>
          </div>
          <div class="clearfix"></div>
        </div> 
      </b-modal>
    </div>
</template>

<script>

import GridMixin from '@/components/grid/Grid.mixin';
import ModalMixin from '@/mixins/modal.mixin';
import Typeahead from 'vue-typeahead-bootstrap';
var jsonp = require('jsonp');
import debounce from 'debounce';

export default {
  name: "DonorAddress",
  mixins: [GridMixin, ModalMixin],
  props: ["id","data", "regions", "isReadonly"],
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    Typeahead
  },
  data() {
    return {
      row: {},
      initRow: { region_id: '', street: '', house: '', building: '', ap: '', city: '', donor_id: '' },
      kladrUrl: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
      token: 'fb51c58ae535e1141f82ab04190365e63c4b8f8c',
      currentIndex: -1,
      renderKey: 0,
      cityQuery: '',
      streetQuery: '',
      cities: [],
      currentCity: [],
      streets: [],
    };
  },
  methods: {
    regionChanged(id) {
      this.row.region_name = id ? this.regions.find(t => t.key == id).value : '';
      this.row.region = null;
    },
    findCity: debounce(function (firstLoad) {
      let self = this;

      var options = {
          method: "POST",
          mode: "cors",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": "Token " + self.token
          },
          body: JSON.stringify({ query: self.row.city,  "from_bound": { "value": "city" }, "to_bound": { "value": "city" } })
      }

      fetch(self.kladrUrl, options)
      .then(response => response.json())
      .then(response => {
        self.cities = response.suggestions.map(m => m.data);
        if(firstLoad === true && self.cities.length > 1) {
          self.currentCity = self.cities[0];
        }
      });
    }, 300),
    findStreet: debounce(function () {
      let self = this;
      var options = {
          method: "POST",
          mode: "cors",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
              "Authorization": "Token " + self.token
          },
          body: JSON.stringify({ query: self.row.street,  "from_bound": { "value": "street" }, "to_bound": { "value": "street" }, "locations": [{ "kladr_id": this.currentCity.city_kladr_id }] })
      }

      fetch(self.kladrUrl, options)
      .then(response => response.json())
      .then(response => {
        self.streets = response.suggestions.map(m => m.data);
      });
    }, 300),
    editRow(index) {
      this.cities = [];
      this.row =  Object.assign({}, index >= 0 ? this.data[index] : this.initRow);
      if(this.row.city) {
        this.findCity(true);
      }
      this.currentIndex = index;
      this.showModal('edit-address-modal');
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.row.donor_id = this.id;
          if(this.currentIndex >= 0) {
            this.data[this.currentIndex] = this.row;
          } else {
            this.data.push(this.row);
          }
          this.renderKey++;
          this.hideModal('edit-address-modal');
        }
      });
    }
  }
};
</script>
